export default {"src":"/_next/static/media/coin.10e83061.svg","height":18,"width":18};